const firebaseConfig = {
    apiKey: "AIzaSyAOmyIMxPR2jH0OtABP3HztxTyIutZUtGM",
    authDomain: "assignment-9-red-onion.firebaseapp.com",
    databaseURL: "https://assignment-9-red-onion.firebaseio.com",
    projectId: "assignment-9-red-onion",
    storageBucket: "assignment-9-red-onion.appspot.com",
    messagingSenderId: "135303594869",
    appId: "1:135303594869:web:3f160b5f7353c36af4093c"
  };
  export default firebaseConfig;